import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "#252729",
                d: "M10.4 3c4.64 0 8.4 3.76 8.4 8.4 0 1.891-.625 3.636-1.68 5.04l3.85 3.348c.33.285.364.782.079 1.11-.286.329-.783.364-1.111.078l-3.877-3.37c-1.493 1.363-3.48 2.194-5.661 2.194-4.64 0-8.4-3.76-8.4-8.4C2 6.76 5.76 3 10.4 3zm0 1.575c-3.77 0-6.825 3.056-6.825 6.825 0 3.77 3.056 6.825 6.825 6.825 3.77 0 6.825-3.056 6.825-6.825 0-3.77-3.056-6.825-6.825-6.825z",
                transform: "translate(-329 -68) translate(0 48) translate(319 10) translate(10 10)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }